import React, { useState } from "react";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import { connect } from "react-redux";

function EditCommentary(props) {
  const userId = localStorage.getItem("user_id");

  const commentaryToEdit = {
    user_id: userId,
    book: props.book,
    chapter: props.chapter,
    commentary: props.commentary,
  };

  const [editedCommentary, setEditedCommentary] = useState(commentaryToEdit);

  function handleEditChange(e) {
    setEditedCommentary({
      ...editedCommentary,
      [e.target.name]: e.target.value,
    });
  }

  async function editCommentary(e) {
    e.preventDefault();
    await updateDoc(doc(db, 'commentaries', props.commId), {
      commentary: editedCommentary.commentary,
    });
    if (props.onSaved) await props.onSaved();
    props.setShowEditForm(false);
  }

  return (
    <div className="roundedbox">
      <br></br>
      <form onSubmit={editCommentary} id="editcommentaryform">
        <textarea
          className="edittext"
          name="commentary"
          form="editcommentaryform"
          value={editedCommentary.commentary}
          onChange={handleEditChange}
        ></textarea>
        <button id="bigbutton" type="submit" disabled={!editedCommentary.commentary.trim()}>
          Save My Commentary
        </button>
        <button id="bigbutton" type="button" onClick={() => props.setShowEditForm(false)}>
          Cancel
        </button>
        <br></br>
        <br></br>
      </form>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    first_name: state.first_name,
    last_name: state.last_name,
  };
};

export default connect(mapStateToProps, {})(EditCommentary);
